import { FeatureFlags } from '../constants/FeatureFlags';
import { usePublicFeatureFlags } from './usePublicFeatureFlags';
export function useIsHubSpotOnCredits() {
  const {
    featureFlags,
    loading
  } = usePublicFeatureFlags();
  return {
    isHubSpotOnCreditsV1: featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS),
    isHubSpotOnCreditsV2: featureFlags.includes(FeatureFlags.HUBSPOT_ON_CREDITS_V2),
    loading
  };
}